<template>
  <validation-observer ref="documentCardObserver" novalidate tag="form">
    <div class="row">
      <div class="col-md-10 text-bold bold">
        <i class=" fa fa-file-upload color-orange" />
        Sección de Documentos
      </div>
      <div class="col-md-2 text-right">
        <action-button
          class="pl-3 transparent"
          i="fas fa-times-circle"
          @click="$emit('on-cancel')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <label class="mt-3">Anejar Documentos</label>
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-drop-down
            v-model="document.documentTypeId"
            :clearable="false"
            custom-error-msg="Favor seleccionar un Tipo de Documento"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Tipo de Documento:"
            :options="documentTypes"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-md-5">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-file-input
            ref="fileUpload2"
            v-model="document.File"
            accept=".pdf"
            :attachment-id="document.Id"
            :error="errors[0]"
            label="Archivo:"
            label-position="left"
            :max-size="10"
            :name="document.FileName"
            required
            :value="document.File"
          />
        </validation-provider>
      </div>

      <div class="col-md-4 text-right mt-4 pt-1">
        <action-button
          i="fas fa-times-circle"
          variant="outline-danger mr-3"
          @click="clearForm()"
        >
          Cancelar
        </action-button>
        <action-button i="fas fa-save" variant="success" @click="submit()">
          Guardar
        </action-button>
      </div>
    </div>
    <div v-if="documents.length" class="row">
      <div class="col-12">
        <label class="mt-3">Documentos Anejados</label>
      </div>
      <div class="col-12">
        <callout
          v-for="item in documents"
          :key="item.documentId"
          ref="callout"
          class="w-100 mt-3"
          :has-border="false"
          :has-toggle="false"
        >
          <div class="row">
            <div class="col-md-5">
              <div class="data-label">Tipo de documento:</div>
              <span class="data">{{ item.documentTypeName }}</span>
            </div>
            <div class="col-md-5">
              <div class="data-label">Archivo:</div>
              <span class="data">{{ item.filename }}</span>
            </div>
            <div class="col-md-2 d-flex">
              <drop-down
                class="align-self-center"
                :data-item="item"
                :items="actionItems"
                :responsive="true"
              />
            </div>
          </div>
        </callout>
      </div>
      <div class="col-12">
        <pagination
          v-if="pagination.totalItemCount > pagination.perPage"
          :data="pagination"
          :show-text="true"
          @pagination-go-page="onSearch"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import Callout from 'custom-callout';
import Pagination from 'pagination';
import alertMixin from '@/mixins/alert.mixin';
import {
  getDocumentTypes as _getDocumentTypes,
  uploadDocument as _uploadDocument,
} from '@/modules/shared/cardhandlingdocument.api.js';
import {
  getEvidenceDocumentSearchResult as _getEvidenceDocumentSearchResult,
  deleteEvidenceDocument as _deleteEvidenceDocument,
} from '@/modules/shared//cardHandling.api';
import peiServices from '@/modules/app/api';
import { serialize as objectToFormData } from 'object-to-formdata';
import CustomFileInput from '@/components/common/CustomFileInput';

export default {
  name: 'DocumentCard',
  components: {
    CustomFileInput,
    CustomDropDown,
    Callout,
    Pagination,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data: () => ({
    document: {
      Id: null,
      File: null,
      FileName: null,
      documentTypeId: null,
    },
    documentTypes: [],
    documents: [],
    pagination: {
      perPage: 5,
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 0,
      count: 0,
    },
  }),
  computed: {
    actionItems() {
      return [
        {
          name: 'view-document',
          label: 'Descargar',
          icon: 'fas fa-download color-primary-1',
          click: (item) =>
            peiServices.downloadDocumentByAttachmentId(item.documentId),
        },
        {
          name: 'delete',
          label: 'Eliminar',
          icon: 'fas fa-times-circle color-red',
          click: this.deleteDocument,
        },
      ];
    },
  },
  mounted() {
    this.onSearch();
    this.getDocumentTypes();
  },
  methods: {
    async submit() {
      const isValid = await this.$refs.documentCardObserver.validate();
      if (isValid) {
        const document = objectToFormData({
          Id: this.id,
          DocumentTypeId: this.document.documentTypeId.id,
          File: this.document.File,
          FileName: this.document.FileName,
          Date: new Date().toLocaleDateString(),
        });
        _uploadDocument(document)
          .then((res) => {
            if (res.data) {
              this.ShowToast(
                'Confirmación',
                'Los cambios fueron guardados exitosamente.',
                'success'
              );
              this.$refs.documentCardObserver.reset();
              this.clearForm();
              this.onSearch();
            }
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
      }
    },
    async getDocumentTypes() {
      const docuTypes = await _getDocumentTypes();
      this.documentTypes = docuTypes.data;
    },
    async deleteDocument(document) {
      let response = await this.ShowCancelModal(
        'Atención',
        `¿Está seguro que desea eliminar el documento ${document.filename}?`,
        'Aceptar',
        'Cancelar'
      );
      if (!response) return;
      await _deleteEvidenceDocument(document.documentId)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'El documento fue eliminado exitosamente.',
            'success'
          );
          this.onSearch();
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async onSearch(page = 1) {
      const mappedFilter = {
        pageIndex: page,
        cardId: this.id,
        PageSize: this.pagination.perPage,
      };
      await _getEvidenceDocumentSearchResult(mappedFilter).then((res) => {
        this.documents = res.data.data;
        this.pagination = {
          ...this.pagination,
          totalItemCount: res.data.totalItemCount,
          pageCount: res.data.pageCount,
          currentPage: res.data.currentPage,
          count: res.data.count,
        };
      });
    },
    clearForm() {
      this.document.documentTypeId = null;
      this.document.File = null;
      this.$refs.fileUpload2.removeFile();
    },
  },
};
</script>
<style scoped lang="scss"></style>
